import DOMPurify from "dompurify";

// Tiny markdown -> HTML formatter (safe-ish for our trusted LLM output)
// Handles **bold**, headings (# ## ###), bullet lists, line breaks, horizontal rules.
// Output is sanitized with DOMPurify before rendering.
export function formatAnswer(text) {
  if (!text) return "";
  // Escape HTML
  let s = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  // Horizontal rules
  s = s.replace(/^\s*---+\s*$/gm, "<hr/>");

  // Headings
  s = s.replace(/^###\s+(.+)$/gm, "<h3>$1</h3>");
  s = s.replace(/^##\s+(.+)$/gm, "<h2>$1</h2>");
  s = s.replace(/^#\s+(.+)$/gm, "<h2>$1</h2>");

  // Bold
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

  // Bullet lists
  s = s.replace(/(?:^|\n)((?:[-*]\s+.+\n?)+)/g, (block) => {
    const items = block
      .trim()
      .split(/\n/)
      .map((l) => l.replace(/^[-*]\s+/, "").trim())
      .filter(Boolean)
      .map((it) => `<li>${it}</li>`)
      .join("");
    return `\n<ul>${items}</ul>\n`;
  });

  // Paragraphs (double newline)
  s = s
    .split(/\n{2,}/)
    .map((p) => {
      if (/^<(h1|h2|h3|ul|ol|hr)/.test(p.trim())) return p;
      return `<p>${p.replace(/\n/g, "<br/>")}</p>`;
    })
    .join("\n");

  // Sanitize final HTML — allow only the tags we produce
  return DOMPurify.sanitize(s, {
    ALLOWED_TAGS: ["h2", "h3", "p", "strong", "em", "ul", "ol", "li", "br", "hr", "code"],
    ALLOWED_ATTR: [],
  });
}

const CITATION_RULES = [
  { tag: "STF", test: /\bSTF\b/ },
  { tag: "STJ", test: /\bSTJ\b/ },
  {
    tag: "Lei",
    test: /\b(art\.?|artigo)\s*\d|\bLei\s*n[º°]?\s*\d|\bCLT\b|\bCF\/?88\b|\bCódigo\s+Civil\b|\bCDC\b/i,
  },
  {
    tag: "Jurisprudência",
    test: /\bsúmula\b|\bjurisprud[êe]ncia\b|\btema\s+\d/i,
  },
];

export function detectCitations(text) {
  if (!text) return [];
  return CITATION_RULES.filter((rule) => rule.test.test(text)).map((rule) => rule.tag);
}
